const projects = [
	{
		image: "Alertify.png",
		title: "Alertify",
		description:
			"Alertify is a powerful application built using Next JS, MongoDB, Twilio, Mongoose, and the Gmail API. Its primary purpose is to provide users with email alerts on WhatsApp, streamlining the process of staying up-to-date with their Gmail inbox. By leveraging real-time notifications, customizable filters, quick actions, message previews, and search functionality, Alertify enhances productivity and convenience in managing emails",
		features: [
			"Real-time notifications: Instantly notify users on WhatsApp about new Gmail messages.",
			"Customizable filters: Set up personalized filters to receive notifications for specific types of emails based on senders or keywords.",
			"Quick actions: Mark emails as read, archive, or delete them directly from WhatsApp.",
			"Message previews: Show a preview of the email message in the WhatsApp notification.",
			"Search functionality: Search Gmail inbox directly from WhatsApp to quickly find specific emails.",
		],
		technology: [
			"Next.js",
			"Twilio",
			"MongoDB",
			"Gmail API",
			"GAPI",
			"Mongoose",
			"JavaScript",
			"HTML",
			"CSS",
			"Tailwind CSS",
		],
		link: "https://github.com/Jayant818/Alertify",
		addOn: "New.png",
	},
	{
		image: "yelpcamp.png",
		title: "YelpCamp",
		description:
			"YelpCamp is a website where users can create and review campgrounds. In order to review or create a campground, you must have an account. This project was created using Node.js, Express, MongoDB, and Bootstrap. Passport.js was used to handle authentication.",
		features: [
			"User Authentication: Sign up, log in, and manage user accounts.",
			"Campground Creation and Editing: Add and update campground information.",
			"Rating and Review System: Rate and provide reviews for campgrounds.",
			"Comment System: Leave comments on campground pages.",
			"Google Maps Integration: Display campground locations using the Google Maps API.",
			"Image Upload: Upload images of campgrounds.",
			"Search Functionality: Search for specific campgrounds based on location or name.",
		],
		technology: [
			"Node.js",
			"Express",
			"MongoDB",
			"Bootstrap",
			"Passport.js",
			"ejs",
			"JavaScript",
			"HTML",
			"CSS",
		],
		link: "https://github.com/Jayant818/Yelpcamp",
	},
	{
		image: "ColorPicker.png",
		title: "React Color Picker",
		description:
			"React Color Picker is an flat ui color picker with perfect color's and codes used for flat designs.It contains 12 Most used Color Palettes & user can create their own color Palette. This is the Clone of the https://flatuicolors.com/, with Some Extra Features",
		features: [
			"Users can create own Color Palette",
			"Can Generate Multiple Shades of same Color",
			"contains 12 Most used Color Palettes",
			"Can Copy Color Code to Clipboard just by clicking on it",
		],
		technology: [
			"React.js",
			"Material-UI",
			"React Router",
			"React Copy to Clipboard",
			"React Transition Group",
			"JavaScript",
			"HTML",
			"CSS",
		],
		link: "https://6223b14c33f9116b0abbc424--angry-engelbart-c7c5fe.netlify.app/",
	},
	{
		image: "youtube.png",
		title: "Youtube Clone",
		description:
			"It is the Clone of Youtube.com. It is made using React.js and Material UI. User can Watch & search the videos.It is a fully responsive website.",
		features: [
			"Users can search for and watch videos.",
			"User can Subscribe & like the Videos",
			"User gets Video Recommendations",
			"User can see other People's Comments",
		],
		technology: [
			"React.js",
			"Material UI",
			"Firebase",
			"Youtube API",
			"JavaScript",
			"HTML",
			"CSS",
			"Tailwind CSS",
		],
		link: "https://jayant-youtube.netlify.app/",
		addOn: "New.png",
	},
	{
		image: "LightOut.png",
		title: "Light-Out",
		description:
			"Lights Out is a logic/puzzle game, played on a gird of individual lights, which can either be lit or unlit. The puzzle is won when when all of the lights are turned off. I am personally TERRIBLE at this game.",
		features: [
			"User can play the game",
			"User can reset the game",
			"User can see the number of moves",
		],
		technology: ["React.js", "JavaScript", "CSS", "HTML"],
		link: "https://github.com/Developer-io-web/Light-Out",
	},
	{
		image: "dadJokes.png",
		title: "Dad Jokes",
		description:
			"This is a great App to get the best (or worst) Dad Jokes. If you're a dad, you'll want this app to torture your children. If you have a dad who tells bad jokes, this is your chance to learn the punchlines so you're prepared.",
		features: [
			"User can get a random joke",
			"User can get a joke by clicking on a button",
			"User can save any Particular joke",
		],
		technology: ["React.js", "Axios", "API", "JavaScript", "CSS", "HTML"],
		link: "https://github.com/Developer-io-web/Dad-Jokes-API-Project",
	},
	{
		image: "Hangman.png",
		title: "React Hangman",
		description:
			"Hangman is a paper and pencil guessing game for two or more players. One player thinks of a word, phrase or sentence and the other (s) tries to guess it by suggesting letters within a certain number of guesses.",
		features: [
			"User can see the correct letters in the word",
			"User can see the letters they have guessed",
			"User can see the number of guesses left",
			"User can see a message when they win or lose",
			"User can reset the game",
		],
		technology: ["React.js", "JavaScript", "CSS", "HTML"],
		link: "https://github.com/Developer-io-web/React-Hangman",
	},
	{
		image: "todoList.png",
		title: "To-Do List App",
		description:
			"It is an To-Do List App, in which You can add new To-dos & also delete, edit and shuffle them.",
		features: [
			"User can add new To-dos",
			"User can delete To-dos",
			"User can edit To-dos",
			"User can shuffle To-dos",
		],
		technology: ["React.js", "JavaScript", "CSS", "HTML"],
		link: "https://github.com/Developer-io-web/Todo-list",
	},

	{
		image: "yahtzee.png",
		title: "Yahtzee",
		description:
			"Yahtzee is a dice game that is played in 13 rounds, each with an objective of meeting the requirements of one of the 13 game categories",
		features: [
			"User can roll the dice",
			"User can hold the dice",
			"User can score the dice",
			"User can see the score",
			"User can see the total score",
			"User can see the winner",
		],
		technology: ["React.js", "JavaScript", "CSS", "HTML"],

		link: "https://github.com/Developer-io-web/Yahtzee",
	},
];

export default projects;
